import cn from 'classnames';
import { memo } from 'react';

import SmallTickIcon from '../SVGIcons/SmallTickIcon';
import classes from './form-checkbox.module.scss';

interface ISelectProps {
  onChange: () => void;
  checked: boolean;
  errors: boolean;
}

function Checkbox({
  onChange,
  checked,
  errors,
}: ISelectProps) {
  return (
    <div
      className={cn(classes.checkbox, {
        [classes['checkbox-checked']]: checked,
        [classes['checkbox-unchecked']]: !checked,
        [classes['checkbox-errors']]: errors,
      })}
      role="none"
      onClick={onChange}
    >
      {checked ? <SmallTickIcon /> : null}
    </div>
  );
}

export default memo(Checkbox);
